export const countryList = [
	'--Select--',
	'South Africa',
	'Afghanistan',
	'Algeria',
	'Angola',
	'Argentina',
	'Australia',
	'Austria',
	'Bahamas',
	'Barbados',
	'Belgium',
	'Botswana',
	'Brazil',
	'Bulgaria',
	'Burkina Faso',
	'Burundi',
	'Cambodia',
	'Cameroon',
	'Cayman Islands',
	'Chad',
	'Chile',
	'China',
	'Colombia',
	'Congo',
	'Cote D Ivoire',
	'Cuba',
	'Egypt',
	'El Salvador',
	'Ethiopia',
	'Finland',
	'France',
	'Gabon',
	'Germany',
	'Ghana',
	'Greece',
	'Greenland',
	'Guam',
	'Guatemala',
	'Guernsey',
	'Guinea',
	'Guinea Bissau',
	'Haiti',
	'Hong Kong',
	'Hungary',
	'India',
	'Iraq',
	'Ireland',
	'Israel',
	'Italy',
	'Jamaica',
	'Japan',
	'Jersey',
	'Jordan',
	'Kenya',
	'Lesotho',
	'Liberia',
	'Libya',
	'Madagascar',
	'Malawi',
	'Malaysia',
	'Mali',
	'Mauritius',
	'Mexico',
	'Mozambique',
	'Namibia',
	'Nepal',
	'Netherlands',
	'New Zealand',
	'Niger',
	'Nigeria',
	'Norway',
	'Pakistan',
	'Palestine',
	'Paraguay',
	'Peru',
	'Philippines',
	'Poland',
	'Portugal',
	'Puerto Rico',
	'Qatar',
	'Romania',
	'Russia',
	'Rwanda',
	'Saudi Arabia',
	'Slovakia',
	'Senegal',
	'Serbia',
	'Seychelles',
	'Sierra Leone',
	'Singapore',
	'South Korea',
	'Spain',
	'Sudan',
	'Swaziland',
	'Sweden',
	'Switzerland',
	'Syria',
	'Taiwan',
	'Tanzania',
	'Thailand',
	'Tunisia',
	'Turkey',
	'Uganda',
	'Ukraine',
	'United Arab Emirates',
	'United Kingdom',
	'Venezuela',
	'Vietnam',
	'Zambia',
	'Zimbabwe',
]
